var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyGinneSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 37,
    viewBox: "0 0 56 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3126 0.264524C40.3359 0.752883 40.0002 2.03483 40.6411 2.98102C41.1295 3.77461 41.1905 3.77461 44.8838 3.77461H48.6075L40.0002 12.3819L31.3623 21.0198L27.6386 17.3266C25.563 15.2816 23.6401 13.5418 23.3654 13.4502C23.0602 13.3281 22.5413 13.3587 22.2361 13.4807C21.2594 13.847 0.2294 33.7782 0.0462655 34.5412C-0.320004 35.9148 1.57239 37.5324 2.76276 36.8304C3.03747 36.7083 7.55479 32.4962 12.8657 27.4906C18.1461 22.5154 22.6024 18.4254 22.7245 18.4254C22.8465 18.4254 24.6779 20.1346 26.7839 22.2407C29.5615 24.9877 30.8434 26.056 31.3623 26.056C31.9117 26.056 34.5061 23.6447 41.801 16.3804L51.4766 6.70476L51.5682 10.4895L51.6597 14.3049L52.5144 14.7016C53.1859 15.0374 53.4911 15.0374 54.1931 14.7016L55.0172 14.3049L55.1088 7.62044C55.1698 3.07259 55.0783 0.813928 54.8341 0.539226C54.4068 0.0203443 42.2893 -0.223835 41.3126 0.264524Z",
    fill: "#133984"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyGinneSales);
export default __webpack_public_path__ + "static/media/myGinneSales.360c7c993ea051bb942c7f444fb33165.svg";
export { ForwardRef as ReactComponent };